import Aboutus from "../pages/Aboutus";
import Board from "../pages/Board";
import BoardDetail from "../pages/Board/BoardDetail";
import Education from "../pages/Education";
import History from "../pages/History";
import Home from "../pages/Home";
import Info from "../pages/Info";
import KPop from "../pages/Kpop";
import Notice from "../pages/Notice";
import NoticeDetail from "../pages/Notice/NoticeDetail";
import Organization from "../pages/Organization";
import Qualifications from "../pages/Qualifications";

export const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aboutus",
    element: <Aboutus />,
  },
  {
    path: "/history",
    element: <History />,
  },
  {
    path: "/organization",
    element: <Organization />,
  },
  {
    path: "/info",
    element: <Info />,
  },
  {
    path: "/education",
    element: <Education />,
  },
  {
    path: "/qualifications",
    element: <Qualifications />,
  },
  {
    path: "/kpop",
    element: <KPop />,
  },
  {
    path: "/board",
    element: <Board />,
  },
  {
    path: "/board/:id",
    element: <BoardDetail />,
  },
  {
    path: "/notice",
    element: <Notice />,
  },
  {
    path: "/notice/:id",
    element: <NoticeDetail />,
  },
];
